import API from "./api";
import { EMPLOYEE_REPORT } from "./endpoint";


export const employee_report = ({ search, status, fromDate, toDate }) => {
  console.log("Calling API with:", { search, status, fromDate, toDate });
  return API.get(EMPLOYEE_REPORT, {
    params: { search, status, fromDate, toDate },
  });
};
